import React from 'react';
import ComingSoon from '@/components/shared/ComingSoonSection';
import './AssessmentPage.scss';

const AssessmentPage = () => {
  return (
    <div className="AssessmentPage">
      <ComingSoon title="AssessmentPage" />
    </div>
  );
};

export default AssessmentPage;